import { render } from "./ViewCategories.vue?vue&type=template&id=5d45ddb0&scoped=true"
import script from "./ViewCategories.vue?vue&type=script&lang=js"
export * from "./ViewCategories.vue?vue&type=script&lang=js"

import "./ViewCategories.vue?vue&type=style&index=0&id=5d45ddb0&scoped=true&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d45ddb0"]])

export default __exports__